export default __webpack_public_path__ + "static/media/build-2.7253aadf.png";